module.exports = __webpack_public_path__ + "static/media/zero.5bee4df5.svg";